/** The kinds the API can restore from the trash; the API handles the same names. */
export const TRASH_TYPES = ['test', 'subject', 'question', 'collection'] as const;

/** How long the Undo button stays on a delete toast. */
export const UNDO_DURATION_MS = 8000;
